import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContext, WeezHeader, Card } from '@weezevent/nacre';
import ExportPeriod from '../services/exportPeriod';
import ExportButton from '../../components/export/exportButton';
import moment from 'moment-timezone';

export default function ServicesReport() {
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const mappingHeaders = [
        { header: t('ticket.tools.export.headers.id_orga'), target: 'id_orga' },
        { header: t('ticket.tools.export.headers.id_event'), target: 'id_event' },
        { header: t('ticket.tools.export.headers.start_date'), target: 'start_date' },
        { header: t('ticket.tools.export.headers.end_date'), target: 'end_date' },
        { header: t('ticket.tools.export.headers.ttc_wo_commission'), target: 'ttc_wo_commission' },
        { header: t('ticket.tools.export.headers.ht_wo_commission'), target: 'ht_wo_commission' },
        { header: t('ticket.tools.export.headers.ttc_sold_price'), target: 'ttc_sold_price' },
        { header: t('ticket.tools.export.headers.ht_sold_price'), target: 'ht_sold_price' },
        { header: t('ticket.tools.export.headers.weezevent_commission_ttc'), target: 'weezevent_commission_ttc' }
    ];

    return (
        <div>
            <WeezHeader title={t('ticket.tools.export.header')} />
            <Card>
                <Card.Header>{t('ticket.tools.export.export-title')}</Card.Header>
                <Card.Content>
                    <ExportPeriod onStartDate={setStartDate} onEndDate={setEndDate} section={false} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ExportButton
                            choiceProcess={'accounting_services_config'}
                            onError={() => toast.error(t('ticket.export.download_state_error'))}
                            selectedPeriod={{ startDate: moment(startDate), endDate: moment(endDate) }}
                            matchingData={mappingHeaders}
                            datesFormat={{
                                from_date: date => moment(date).format('YYYY-MM-DD'),
                                to_date: date => moment(date).format('YYYY-MM-DD')
                            }}
                        />
                    </div>
                </Card.Content>
            </Card>
        </div>
    );
}
